export class LogLevel {
  public static readonly trace: string = 'TRACE';

  public static readonly debug: string = 'DEBUG';

  public static readonly info: string = 'INFO';

  public static readonly warn: string = 'WARN';

  public static readonly error: string = 'ERROR';

  public static readonly critical: string = 'CRITICAL';
}
